module.exports = __webpack_public_path__ + "static/media/loading.354a3d83.gif";